// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"755":"7d11424b","808":"63f64502"}[chunkId] + ".css";
};